module.exports = __webpack_public_path__ + "static/flexibilidade-tab-16ffda073a8bbd477eebfde286c24f52.png";